import { Flow_0_0_2 } from '@flexus/core';

export const BET_47: Flow_0_0_2 = {
	id: '47',
	name: 'invoice_query_invalid_claim',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to respond'
		}
	},
	startNode: '',
	nodes: {}
};
